module.exports = __webpack_public_path__ + "img/add_apple_wallet.ffcf7b67.png";